import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

interface Props {
    checked?:boolean
    onChange?():void
}

const Switcher:React.FC<Props> = ({checked, onChange}) => {
    
    return (
        <AntSwitch
            onChange={() => {
                if(typeof  onChange === "function") {
                    onChange()
                }
            }}
            // defaultChecked={checked}
            checked={checked}
        />
    );
}

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 56, // Increase width for a bigger switch
    height: 26, // Increase height for a bigger switch
    padding: 0,
    display: 'flex',
    boxShadow: "none !important",
    
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 30, // Adjust thumb size on active state
            height: 18, // Adjust thumb size on active state
            boxShadow: "none !important",
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(18px)', // Adjust checked state position
            boxShadow: "none !important",
        },
    },
    
    '& .MuiSwitch-switchBase': {
        padding: 4, // Increase padding for a bigger switch
        boxShadow: "none !important",
        '&.Mui-checked': {
            transform: 'translateX(30px)', // Adjust checked state position
            color: '#fff',
            boxShadow: "none !important",
            
            '& + .MuiSwitch-track': {
                boxShadow: "none !important",
                opacity: 1,
                backgroundColor: '#007626', // Green color for the track when checked
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: "none !important",
        width: 18, // Adjust thumb size
        height: 18, // Adjust thumb size
        borderRadius: 100, // Adjust border radius for a rounded thumb
        transition: theme.transitions.create(['width', 'height'], {
            duration: 100,
        }),
    },
    '& .MuiSwitch-track': {
        boxShadow: "none !important",
        borderRadius: 16, // Adjust border radius for the track
        opacity: 1,
        backgroundColor: '#ccc', // Gray color for the track when not checked
        boxSizing: 'border-box',
    },
}));

export default Switcher;
